import { useCasinoStore, usePlayerStore } from '../../services/store'

export const useFlashGameIconTout = () => {
  const playerStore = usePlayerStore()
  const playerActiveCurrencyData = playerStore.use.playerActiveCurrencyData()

  const casinoStore = useCasinoStore()
  const casinoFlashPrizeGames = casinoStore.use.casinoFlashPrizeGames()

  const getShowFlashPrizeIcon = gameId => {
    const flashPrizeGame = casinoFlashPrizeGames && casinoFlashPrizeGames[gameId]

    if (
      flashPrizeGame &&
      !flashPrizeGame.isExpired &&
      flashPrizeGame.currencies.includes(playerActiveCurrencyData.currencyName)
    ) {
      return !flashPrizeGame.hasDiamondReward
    } else {
      return false
    }
  }

  const getShowFlashDiamondIcon = gameId => {
    const flashPrizeGame = casinoFlashPrizeGames && casinoFlashPrizeGames[gameId]

    if (
      flashPrizeGame &&
      !flashPrizeGame.isExpired &&
      flashPrizeGame.currencies.includes(playerActiveCurrencyData.currencyName)
    ) {
      return flashPrizeGame.hasDiamondReward
    } else {
      false
    }
  }

  return { getShowFlashPrizeIcon, getShowFlashDiamondIcon }
}
